<template>
  <v-pagination
    :value="value"
    :length="length"
    :total-visible="totalVisible"
    @input="transition"
  >
  </v-pagination>
</template>

<script>
import "vuetify/dist/vuetify.min.css";

export default {
  name: "vc-share-transition-pagination",
  props: {
    value: {
      type: Number,
      default: 0
    },
    length: {
      type: Number,
      default: 0
    },
    totalVisible: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      default: ""
    }
  },
  data: () => {
    return {};
  },
  methods: {
    transition: function(page) {
      const url = this.url.replace(/\${page}/, page);
      location.href = url;
    }
  }
};
</script>

<style></style>
